import request from '@/utils/request'

//getResNoList
export function getResNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/getResNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getLocNoList
export function getLocNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/getLocNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa022head
export function epmsa022head(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa022head`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa022detail
export function epmsa022detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa022detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa021Block
export function epmsa021Block(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa021Block`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa023List
export function epmsa023List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa023List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa020save
export function epmsa020save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa020save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa020delete
export function epmsa020delete(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa020delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


//epmsa022xls
export function epmsa022xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa020/epmsa022xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `General Material Carry-Out.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}